<div class="default-size" *ngIf="context.size === 'default'">
  <div class="header" *ngIf="!context.withoutHeading">
    <h2
      [id]="context.id"
      [class.ait-font-text-m]="!context.content || context.headingAsBody"
      [class.ait-font-bold-m]="context.content && !context.headingAsBody"
    >
      {{ context.heading | translate }}
    </h2>
    <button
      class="tui-space_left-2"
      *ngIf="context.closeable"
      [title]="closeWord$ | async"
      (click)="close(false)"
      tuiIconButton
      tuiPreventDefault="mousedown"
      size="s"
      appearance="aitarget-flat"
      icon="tuiIconCloseLarge"
      shape="rounded"
    ></button>
  </div>
  <section>
    <ng-container *polymorpheusOutlet="context.content as text; context: context">
      {{ text }}
    </ng-container>
  </section>
  <p class="buttons" *ngIf="!context.customButtons" [class.bordered-buttons]="context.closeable">
    <button
      class="tui-space_right-4"
      [appearance]="context.buttons[0].appearance"
      (click)="close(false)"
      tuiButton
      size="m"
    >
      {{ context.buttons[0].title | translate }}
    </button>
    <button [appearance]="context.buttons[1].appearance" (click)="close(true)" tuiButton size="m">
      {{ context.buttons[1].title | translate }}
    </button>
  </p>
</div>
<div class="page-size" *ngIf="context.size === 'page'">
  <section>
    <ng-container *polymorpheusOutlet="context.content as text; context: context">
      {{ text }}
    </ng-container>
  </section>
</div>
